// extracted by mini-css-extract-plugin
export default {"rating":"Iz-z","numberOfStars":"Jz-z","count":"Kz-z","barGraphSpacing":"Lz-z","barGraph":"Mz-z"};